import { Component } from '@angular/core';
import { Toast } from '@app/core/models/common.models';
import { pollUntilClose } from '@app/core/utilities/dom.utilities';
import { TranslateService } from '@ngx-translate/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  standalone: false,
  selector: 'adspt-re-login-modal',
  templateUrl: './re-login-modal.component.html',
  styleUrls: ['./re-login-modal.component.scss'],
})
export class ReLoginModalComponent {
  readonly toast: Toast = { show: false, title: '', type: 'error' };
  cancel() {
    this.modal.close(false);
  }
  success() {
    this.modal.close(true);
    this.toast.show = true;
    this.toast.type = 'success';
    this.toast.title = this.translate.instant('common.re-login.re-try');
  }
  error() {
    this.modal.close(false);
    this.toast.show = true;
    this.toast.type = 'error';
    this.toast.title = this.translate.instant('portal.creds-error');
  }
  onLoginAuth0(): void {
    const url = new URL(`${location.origin}/auth/login`);
    url.searchParams.append('redirect', `/monitor?close=true`);

    const popup = window.open(
      url,
      '_blank',
      `popup,width=500,height=540,left=${window.innerWidth / 2 - 250},top=${window.innerHeight / 2 - 270}`,
    );

    pollUntilClose(popup).then(() => {
      this.modal.close(true);
    });
  }

  constructor(
    private translate: TranslateService,
    private modal: NzModalRef,
  ) {}
}
